import type { DateTime } from 'luxon';

export const isSameFilterDate = (a: DateTime | undefined, b: DateTime | undefined): boolean => {
  const validA: DateTime | undefined = a?.isValid ? a : undefined;
  const validB: DateTime | undefined = b?.isValid ? b : undefined;

  if (!validA || !validB) {
    return !validA && !validB;
  }

  return validA.hasSame(validB, 'day');
};
